import React, { useState, useMemo, useEffect } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useParams } from 'react-router-dom';
import { identity, pickBy } from 'lodash';
import { useCollect } from 'hooks';

import { Button } from 'components/Misc/Form';
import * as Table from 'components/Misc/Table';
import Progress from 'components/Misc/Progress';
import Container from 'components/Misc/Container';

import Unassigned from 'containers/Shared/Courses/Profile/Studentz/Unassigned';
import Search from 'containers/Shared/Courses/Profile/Studentz/Search';
import Student from 'containers/Shared/Courses/Profile/Studentz/Student';

const Studentz = ({ tab, setTab }) => {
	// Store current object's id
	const { id } = useParams();

	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Store search bar's data
	const [search, setSearch] = useState({
		name: '',
		courseStartDate: '',
		courseEndDate: '',
		examStartDate: '',
		examEndDate: '',
		examState: '',
		examMark: ''
	});

	// Store request parameters
	const parameters = useMemo(() => pickBy({
		condition: 'students',
		'courserel.courseId': id,
		'name|surname:likeLower': `%${search.name}%`,
		'courserel.startDate:gte': search.courseStartDate,
		'courserel.endDate:lte': search.courseEndDate,
		'takes.startDate:gte': search.examStartDate,
		'takes.endDate:lte': search.examEndDate,
		'takes.state': search.examState,
		'takes.mark': search.examMark,
		'orderBy': 'courserel.startDate'
	}, identity), [id, search]);

	// Store requested students
	const [[students, progress], collect] = useCollect(`courses/${id}`, parameters);

	// Handle search input change
	const onSearch = ({ name, value }) => {
		setSearch(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Collect students on mount
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<>
			{/* Unassigned student actions */}
			<Unassigned refresh={collect} />

			{/* Search container */}
			<Search search={search} onChange={onSearch} />

			{/* Show loading progress */}
			<Progress progress={progress} />

			<div className="mt-4 bg-white rounded-lg">
				{/* Header row */}
				<div className="py-3 px-4 flex items-center space-x-2 text-neutral-700 font-normal text-sm">
					<div className="w-7"></div>
					<div className="flex-1">Students</div>
					<div className="w-28">Sākuma datums</div>
					<div className="w-28">Beigu datums</div>
					<div className="w-24">Statuss</div>
					<div className="w-7"></div>
					<div className="w-7"></div>
				</div>

				{/* Student collection */}
				{students?.map(student =>
					<Student key={student.id} student={student} />
				)}
			</div>
		</>
	);
};

export default Studentz;